<div class="admin-marketing">
  <div class="header-actions">
    <button class="btn-back" (click)="goBack()">
      <span class="back-icon">←</span>
      <span>Back to Dashboard</span>
    </button>
    <button class="btn-refresh" (click)="onRefresh()" [disabled]="loading">
      <span class="refresh-icon">⟳</span>
      <span>Refresh Data</span>
    </button>
  </div>

  <div class="page-header">
    <div class="header-content">
      <div class="welcome-section">
        <h1 class="page-title">Marketing Center</h1>
        <p class="page-subtitle">
          Manage email campaigns and subscriber communications
        </p>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !stats" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading marketing data...</p>
  </div>

  <div *ngIf="error && !loading" class="error-container">
    <div class="error-card">
      <h3>Error Loading Marketing Data</h3>
      <p>{{ error }}</p>
      <button class="btn-retry" (click)="onRefresh()">Try Again</button>
    </div>
  </div>

  <div *ngIf="!loading && !error" class="main-content">
    <div class="stats-section">
      <h2 class="section-title">Marketing Overview</h2>
      <div class="stats-grid">
        <div class="stat-card subscribers">
          <div class="stat-icon">👥</div>
          <div class="stat-content">
            <div class="stat-number">{{ stats?.total_subscribers || 0 }}</div>
            <div class="stat-label">Total Subscribers</div>
            <div class="stat-subtitle">
              {{ stats?.active_subscribers || 0 }} active subscribers
            </div>
          </div>
        </div>

        <div class="stat-card campaigns">
          <div class="stat-icon">📊</div>
          <div class="stat-content">
            <div class="stat-number">{{ stats?.total_campaigns || 0 }}</div>
            <div class="stat-label">Total Campaigns</div>
            <div class="stat-subtitle">All time campaigns</div>
          </div>
        </div>

        <div class="stat-card emails">
          <div class="stat-icon">📧</div>
          <div class="stat-content">
            <div class="stat-number">{{ stats?.total_emails_sent || 0 }}</div>
            <div class="stat-label">Emails Sent</div>
            <div class="stat-subtitle">
              {{ stats?.avg_recipients_per_campaign || 0 | number : "1.0-0" }}
              average per campaign
            </div>
          </div>
        </div>

        <div class="stat-card recent">
          <div class="stat-icon">⏰</div>
          <div class="stat-content">
            <div class="stat-number">{{ getTimeSinceLastCampaign() }}</div>
            <div class="stat-label">Last Campaign</div>
            <div class="stat-subtitle">
              {{ formatDate(stats?.last_campaign_sent) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="quick-actions-section">
      <h2 class="section-title">Quick Actions</h2>
      <div class="actions-grid">
        <div class="action-card primary" (click)="openSendCampaignModal()">
          <div class="action-icon">📧</div>
          <div class="action-content">
            <h3 class="action-title">Send Email Campaign</h3>
            <p class="action-description">
              Create and send marketing emails to your subscriber base
            </p>
          </div>
          <div class="action-arrow">→</div>
        </div>

        <div class="action-card elite" (click)="openListingMarketingModal()">
          <div class="action-icon">⭐</div>
          <div class="action-content">
            <h3 class="action-title">Elite Listings Campaign</h3>
            <p class="action-description">
              Showcase premium Elite plan listings to subscribers
            </p>
          </div>
          <div class="action-arrow">→</div>
        </div>
      </div>
    </div>

    <div class="tabs-section">
      <div class="tabs-header">
        <button
          class="tab-button"
          [class.active]="activeTab === 'campaigns'"
          (click)="setActiveTab('campaigns')"
        >
          Campaign History
        </button>
        <button
          class="tab-button"
          [class.active]="activeTab === 'subscribers'"
          (click)="setActiveTab('subscribers')"
        >
          Subscriber Management
        </button>
      </div>

      <div *ngIf="activeTab === 'campaigns'" class="tab-content">
        <div class="campaigns-section">
          <div class="section-header">
            <h3>Recent Email Campaigns</h3>
          </div>

          <div *ngIf="loadingCampaigns" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading campaign data...</p>
          </div>

          <div
            *ngIf="!loadingCampaigns && (!campaigns || campaigns.length === 0)"
            class="empty-state"
          >
            <div class="empty-icon">📭</div>
            <h3>No campaigns sent yet</h3>
            <p>
              Start building your audience with your first marketing campaign
            </p>
            <button class="btn-primary" (click)="openSendCampaignModal()">
              Send First Campaign
            </button>
          </div>

          <div
            *ngIf="!loadingCampaigns && campaigns && campaigns.length > 0"
            class="campaigns-list"
          >
            <div class="campaign-card" *ngFor="let campaign of campaigns">
              <div class="campaign-header">
                <div class="campaign-info">
                  <h4 class="campaign-title">{{ campaign.title }}</h4>
                  <p class="campaign-subject">{{ campaign.subject }}</p>
                </div>
                <div class="campaign-stats">
                  <span class="stat-badge"
                    >{{ campaign.recipients_count || 0 }} recipients</span
                  >
                  <span class="date-badge">{{
                    formatDate(campaign.sent_at)
                  }}</span>
                </div>
              </div>
              <div class="campaign-meta">
                <span class="sent-by">Sent by {{ campaign.sent_by_name }}</span>
                <button class="btn-view" (click)="viewCampaign(campaign)">
                  View Details
                </button>
              </div>
            </div>

            <div *ngIf="campaignPagination.totalPages > 1" class="pagination">
              <button
                class="btn-page"
                [disabled]="campaignPagination.page === 1"
                (click)="onCampaignPageChange(campaignPagination.page - 1)"
              >
                Previous
              </button>

              <button
                *ngIf="shouldShowCampaignEllipsis('start')"
                class="btn-page"
                (click)="onCampaignPageChange(1)"
              >
                1
              </button>

              <span *ngIf="shouldShowCampaignEllipsis('start')" class="pagination-ellipsis"
              >...</span
              >

              <button
                *ngFor="let page of getCampaignPageNumbers()"
                class="btn-page"
                [class.active]="page === campaignPagination.page"
                (click)="onCampaignPageChange(page)"
              >
                {{ page }}
              </button>

              <span *ngIf="shouldShowCampaignEllipsis('end')" class="pagination-ellipsis"
              >...</span
              >

              <button
                *ngIf="shouldShowCampaignEllipsis('end')"
                class="btn-page"
                (click)="onCampaignPageChange(campaignPagination.totalPages)"
              >
                {{ campaignPagination.totalPages }}
              </button>

              <button
                class="btn-page"
                [disabled]="
                  campaignPagination.page === campaignPagination.totalPages
                "
                (click)="onCampaignPageChange(campaignPagination.page + 1)"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="activeTab === 'subscribers'" class="tab-content">
        <div class="subscribers-section">
          <div class="section-header">
            <h3>Active Subscribers</h3>
            <div class="subscriber-stats">
              <span class="stat-item">
                <strong>{{ subscribers.length }}</strong> Active Subscribers
              </span>
            </div>
          </div>

          <div *ngIf="loadingSubscribers" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading subscriber data...</p>
          </div>

          <div
            *ngIf="subscribers.length === 0 && !loadingSubscribers"
            class="empty-state"
          >
            <div class="empty-icon">👥</div>
            <h3>No subscribers yet</h3>
            <p>
              Users will appear here when they subscribe to marketing emails
            </p>
          </div>

          <div *ngIf="subscribers.length > 0" class="subscribers-list">
            <div class="subscribers-header">
              <div class="search-box">
                <input
                  type="text"
                  placeholder="Search subscribers..."
                  [(ngModel)]="subscriberSearchTerm"
                  (input)="filterSubscribers()"
                  class="search-input"
                />
                <span class="search-icon">🔍</span>
              </div>
            </div>

            <div class="subscribers-table">
              <div class="table-header">
                <div class="col-name">Name</div>
                <div class="col-email">Email Address</div>
                <div class="col-date">Subscribed</div>
                <div class="col-status">Status</div>
              </div>
              <div class="table-body">
                <div
                  class="subscriber-row"
                  *ngFor="let subscriber of filteredSubscribers"
                >
                  <div class="col-name">
                    <div class="subscriber-avatar">
                      {{
                        getInitials(subscriber.first_name, subscriber.last_name)
                      }}
                    </div>
                    <div class="subscriber-info">
                      <span class="name"
                        >{{ subscriber.first_name }}
                        {{ subscriber.last_name }}</span
                      >
                    </div>
                  </div>
                  <div class="col-email">{{ subscriber.email }}</div>
                  <div class="col-date">
                    {{ formatDate(subscriber.created_at) }}
                  </div>
                  <div class="col-status">
                    <span class="status-badge active">Active</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="showSendCampaignModal"
    class="modal-overlay"
    (click)="closeSendCampaignModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Send Marketing Campaign</h3>
        <button class="btn-close" (click)="closeSendCampaignModal()">×</button>
      </div>

      <form
        [formGroup]="campaignForm"
        (ngSubmit)="sendCampaign()"
        class="modal-body"
      >
        <div class="form-group">
          <label for="campaign-title">Campaign Title</label>
          <input
            type="text"
            id="campaign-title"
            formControlName="title"
            placeholder="e.g., Weekly Newsletter - January 2024"
            class="form-input"
            [class.error]="
              campaignForm.get('title')?.invalid &&
              campaignForm.get('title')?.touched
            "
          />
          <div
            *ngIf="
              campaignForm.get('title')?.invalid &&
              campaignForm.get('title')?.touched
            "
            class="error-text"
          >
            Campaign title is required (3-255 characters)
          </div>
        </div>

        <div class="form-group">
          <label for="email-subject">Email Subject Line</label>
          <input
            type="text"
            id="email-subject"
            formControlName="subject"
            placeholder="e.g., New Deals This Week - Don't Miss Out!"
            class="form-input"
            [class.error]="
              campaignForm.get('subject')?.invalid &&
              campaignForm.get('subject')?.touched
            "
          />
          <div
            *ngIf="
              campaignForm.get('subject')?.invalid &&
              campaignForm.get('subject')?.touched
            "
            class="error-text"
          >
            Email subject is required (3-255 characters)
          </div>
        </div>

        <div class="form-group">
          <label for="email-content">Email Content (HTML supported)</label>
          <textarea
            id="email-content"
            formControlName="content"
            placeholder="Write your marketing email content here. You can use HTML tags for formatting."
            rows="10"
            class="form-textarea"
            [class.error]="
              campaignForm.get('content')?.invalid &&
              campaignForm.get('content')?.touched
            "
          ></textarea>
          <div
            *ngIf="
              campaignForm.get('content')?.invalid &&
              campaignForm.get('content')?.touched
            "
            class="error-text"
          >
            Email content is required (minimum 10 characters)
          </div>
          <div class="help-text">
            <small
              >💡 Tip: Use HTML tags like &lt;h1&gt;, &lt;p&gt;, &lt;strong&gt;,
              &lt;a&gt; for better formatting</small
            >
          </div>
        </div>

        <div class="campaign-preview">
          <h4>Campaign Summary</h4>
          <div class="preview-info">
            <p>
              <strong>Recipients:</strong>
              {{ stats?.active_subscribers || 0 }} active subscribers
            </p>
            <p>
              <strong>Subject:</strong>
              {{ campaignForm.get("subject")?.value || "No subject" }}
            </p>
          </div>
        </div>

        <div *ngIf="campaignError" class="alert alert-error">
          <span class="alert-icon">⚠️</span>
          <span>{{ campaignError }}</span>
        </div>

        <div *ngIf="campaignSuccess" class="alert alert-success">
          <span class="alert-icon">✅</span>
          <span>{{ campaignSuccess }}</span>
        </div>
      </form>

      <div class="modal-footer">
        <button
          type="button"
          class="btn-secondary"
          (click)="closeSendCampaignModal()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn-primary"
          [disabled]="campaignForm.invalid || sendingCampaign"
          (click)="sendCampaign()"
        >
          <span *ngIf="!sendingCampaign">Send Campaign</span>
          <span *ngIf="sendingCampaign">
            <div class="button-spinner"></div>
            Sending...
          </span>
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showCampaignDetailsModal && selectedCampaign"
    class="modal-overlay"
    (click)="closeCampaignDetailsModal()"
  >
    <div class="modal-content large" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Campaign Details</h3>
        <button class="btn-close" (click)="closeCampaignDetailsModal()">
          ×
        </button>
      </div>

      <div class="modal-body">
        <div class="campaign-details">
          <div class="detail-section">
            <h4>Campaign Information</h4>
            <div class="detail-grid">
              <div class="detail-item">
                <label>Title</label>
                <span>{{ selectedCampaign.title }}</span>
              </div>
              <div class="detail-item">
                <label>Subject</label>
                <span>{{ selectedCampaign.subject }}</span>
              </div>
              <div class="detail-item">
                <label>Sent By</label>
                <span>{{ selectedCampaign.sent_by_name }}</span>
              </div>
              <div class="detail-item">
                <label>Send Date</label>
                <span>{{ formatDate(selectedCampaign.sent_at) }}</span>
              </div>
              <div class="detail-item">
                <label>Recipients</label>
                <span
                  >{{
                    selectedCampaign.recipients_count || 0
                  }}
                  subscribers</span
                >
              </div>
            </div>
          </div>

          <div class="detail-section">
            <h4>Email Content</h4>

            <div *ngIf="loadingCampaignDetails" class="loading-container">
              <div class="loading-spinner"></div>
              <p>Loading campaign content...</p>
            </div>

            <div
              *ngIf="campaignDetailsError && !loadingCampaignDetails"
              class="alert alert-error"
            >
              <span class="alert-icon">⚠️</span>
              <span>{{ campaignDetailsError }}</span>
            </div>

            <div
              *ngIf="
                !loadingCampaignDetails &&
                !campaignDetailsError &&
                selectedCampaign.content
              "
              class="content-preview"
              [innerHTML]="selectedCampaign.content"
            ></div>

            <div
              *ngIf="
                !loadingCampaignDetails &&
                !campaignDetailsError &&
                !selectedCampaign.content
              "
              class="empty-state"
            >
              <div class="empty-icon">📭</div>
              <h3>No content available</h3>
              <p>This campaign doesn't have any content to display.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn-secondary"
          (click)="closeCampaignDetailsModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showListingMarketingModal"
    class="modal-overlay"
    (click)="closeListingMarketingModal()"
  >
    <div class="modal-content large" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Send Elite Listing Marketing Campaign</h3>
        <button class="btn-close" (click)="closeListingMarketingModal()">
          ×
        </button>
      </div>

      <div class="modal-body">
        <div class="info-box elite">
          <h4>⭐ Elite Listings Campaign</h4>
          <p>
            Showcase premium Elite plan listings to your subscribers. Select the
            listings you want to feature and we'll create a professional
            marketing email highlighting these premium offerings.
          </p>
          <ul>
            <li>✨ Professional email template with listing images</li>
            <li>💎 Elite badge highlighting premium status</li>
            <li>📧 Sent to all active subscribers</li>
            <li>📊 Performance tracking and analytics</li>
          </ul>
        </div>

        <div *ngIf="loadingEliteListings" class="loading-container">
          <div class="loading-spinner"></div>
          <p>Loading Elite listings...</p>
        </div>

        <div
          *ngIf="eliteListingsError && !loadingEliteListings"
          class="alert alert-error"
        >
          <span class="alert-icon">⚠️</span>
          <span>{{ eliteListingsError }}</span>
        </div>

        <div
          *ngIf="
            !loadingEliteListings &&
            !eliteListingsError &&
            eliteListings.length === 0
          "
          class="empty-state"
        >
          <div class="empty-icon">⭐</div>
          <h3>No Elite Listings Available</h3>
          <p>
            There are currently no active Elite plan listings to feature in
            marketing emails.
          </p>
        </div>

        <div
          *ngIf="
            !loadingEliteListings &&
            !eliteListingsError &&
            eliteListings.length > 0
          "
          class="listings-selection"
        >
          <div class="selection-header">
            <h4>Select Elite Listings to Feature</h4>
            <div class="selection-actions">
              <span class="selection-count">
                {{ selectedListings.length }} of
                {{ eliteListings.length }} selected
              </span>
              <button class="btn-secondary" (click)="selectAllListings()">
                Select All
              </button>
              <button class="btn-secondary" (click)="clearAllSelections()">
                Clear All
              </button>
            </div>
          </div>

          <div class="search-box">
            <input
              type="text"
              placeholder="Search listings..."
              [(ngModel)]="listingSearchTerm"
              (input)="filterEliteListings()"
              class="search-input"
            />
            <span class="search-icon">🔍</span>
          </div>

          <div class="listings-grid">
            <div
              class="listing-card"
              *ngFor="let listing of filteredEliteListings"
              [class.selected]="isListingSelected(listing.id)"
              (click)="toggleListingSelection(listing)"
            >
              <div class="listing-checkbox">
                <input
                  type="checkbox"
                  [checked]="isListingSelected(listing.id)"
                  (click)="$event.stopPropagation()"
                  (change)="toggleListingSelection(listing)"
                />
              </div>

              <div class="listing-image">
                <img
                  *ngIf="listing.first_image; else noImage"
                  [src]="listing.first_image"
                  [alt]="listing.title"
                />
                <ng-template #noImage>
                  <div class="no-image-placeholder">📷</div>
                </ng-template>
                <div class="plan-badge elite">💎 Elite</div>
              </div>

              <div class="listing-info">
                <h5 class="listing-title">{{ listing.title }}</h5>
                <div class="listing-price">
                  {{ listing.currency }} {{ listing.price | number : "1.0-2" }}
                </div>
                <div class="listing-category">
                  {{ getCategoryDisplay(listing.table_name) }}
                </div>
                <div class="listing-date">
                  {{ formatDate(listing.created_at) }}
                </div>
                <div class="listing-owner">
                  by {{ listing.user_first_name }} {{ listing.user_last_name }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="listing-campaign-info"
            *ngIf="selectedListings.length > 0"
          >
            <h4>Campaign Details</h4>

            <div class="form-group">
              <label for="listing-campaign-subject">Email Subject Line</label>
              <input
                type="text"
                id="listing-campaign-subject"
                [(ngModel)]="listingCampaignSubject"
                placeholder="Check out these premium listings!"
                class="form-input"
              />
            </div>

            <div class="form-group">
              <label for="listing-campaign-intro"
                >Introduction Message (Optional)</label
              >
              <textarea
                id="listing-campaign-intro"
                [(ngModel)]="listingCampaignIntro"
                placeholder="Discover our handpicked premium listings..."
                rows="3"
                class="form-textarea"
              ></textarea>
            </div>

            <div class="campaign-preview">
              <h4>Campaign Preview</h4>
              <div class="preview-info">
                <p>
                  <strong>Recipients:</strong>
                  {{ stats?.active_subscribers || 0 }} active subscribers
                </p>
                <p>
                  <strong>Featured Listings:</strong>
                  {{ selectedListings.length }} Elite listings
                </p>
                <p>
                  <strong>Subject:</strong>
                  {{
                    listingCampaignSubject ||
                      "Check out these premium listings!"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="listingCampaignError" class="alert alert-error">
          <span class="alert-icon">⚠️</span>
          <span>{{ listingCampaignError }}</span>
        </div>

        <div *ngIf="listingCampaignSuccess" class="alert alert-success">
          <span class="alert-icon">✅</span>
          <span>{{ listingCampaignSuccess }}</span>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn-secondary"
          (click)="closeListingMarketingModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn-primary elite"
          [disabled]="selectedListings.length === 0 || sendingListingCampaign"
          (click)="sendListingMarketingCampaign()"
        >
          <span *ngIf="!sendingListingCampaign">
            Send to {{ stats?.active_subscribers || 0 }} Subscribers
          </span>
          <span *ngIf="sendingListingCampaign">
            <div class="button-spinner"></div>
            Sending...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
